export default __webpack_public_path__ + "static/media/a001-03.6949f06f.svg";